import { useTranslation } from "react-i18next";
import PageWrapper from "../../../../components/common/layout/PageWrapper";
import {
  AppPageContentWrapper,
  BoxSpg,
  PageContentBox,
  HtmlParseText,
  MediumButton,
} from "@duosoftbg/nacid-components";
import { Typography } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faList, faPlus } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import ARUniEntryRequestDescription from "../../../../components/registers/request/arUni/ARUniEntryRequestDescription";

const ARUniEntryRequestPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <PageWrapper centerTitle title={t("t.arUniEntryRequest")}>
      <AppPageContentWrapper>
        <PageContentBox>
          <ARUniEntryRequestDescription />
        </PageContentBox>
        <BoxSpg mt={4}>
          <Typography align={"left"}>
            <MediumButton
              startIcon={<FontAwesomeIcon style={{ fontSize: 12 }} icon={faPlus} />}
              variant="contained"
              color="primary"
              onClick={() => navigate(`/ar-uni-entry-request/new`)}
            >
              {t("l.btn.newEntryRequest")}
            </MediumButton>
            <MediumButton
              ml={2}
              startIcon={<FontAwesomeIcon style={{ fontSize: 12 }} icon={faList} />}
              variant="outlined"
              color="primary"
              onClick={() => navigate("/ar-uni-entry-request/list")}
            >
              {t("l.btn.myEntryRequests")}
            </MediumButton>
          </Typography>
        </BoxSpg>
      </AppPageContentWrapper>
    </PageWrapper>
  );
};
export default ARUniEntryRequestPage;
